import { Coordinate } from 'src/app/models/coordinate/coordinate';
import { SearchAreaGroup } from 'src/app/models/search-area-group/search-area-group';
import { SearchArea } from 'src/app/models/search-area/search-area';
import { Time } from 'src/app/models/time/time';
import { ScotchApiSearchQuery } from '../../../lib/search/scotch-api-search-query';
import { DEFAULT_RADIUS } from '../constants';
import { URLSearchQuery } from './url-search-query';
import { ViewMode } from './view-mode';

export interface Params {
  coordinate?: Coordinate;
  seats?: number;
  startsFromTime?: Time;
  searchArea?: SearchArea;
  searchAreaGroup?: SearchAreaGroup;
  viewMode?: ViewMode;
}

/**
 * 検索パラメーターを表すクラス.
 * 自分自身のデータから、URL 用のパラメーターと、API 用のパラメーターを生成することができる.
 */
export class SearchParams {
  constructor(private readonly params: Params) {}

  get coordinate(): Coordinate | null {
    return this.params.coordinate || null;
  }

  get seats(): number | null {
    if (
      this.params.seats === undefined ||
      !Number.isInteger(this.params.seats)
    ) {
      return null;
    }

    return this.params.seats;
  }

  get searchArea(): SearchArea | null {
    return this.params.searchArea || null;
  }

  get searchAreaGroup(): SearchAreaGroup | null {
    return this.params.searchAreaGroup || null;
  }

  get startsFromTime(): Time | null {
    return this.params.startsFromTime || null;
  }

  get startsFromTimeString(): string | null {
    if (this.startsFromTime === null) {
      return null;
    }
    return this.startsFromTime.toUtcISOString();
  }

  get viewMode(): ViewMode | null {
    return this.params.viewMode || null;
  }

  isAreaSearch(): boolean {
    return this.searchArea !== null;
  }

  toURLSearchQuery(): URLSearchQuery {
    const params: URLSearchQuery = {
      seats: null,
      lat: null,
      lng: null,
      area: null,
      areaGroup: null,
      startsFromTime: null,
      view: null,
    };

    if (this.seats !== null) {
      params.seats = this.seats.toString();
    }

    if (this.coordinate !== null) {
      params.lat = this.coordinate.lat.toString();
      params.lng = this.coordinate.lng.toString();
    }

    if (this.searchArea !== null) {
      params.area = this.searchArea.key;
    }

    if (this.searchAreaGroup !== null) {
      params.areaGroup = this.searchAreaGroup.key;
    }

    if (this.startsFromTime !== null) {
      params.startsFromTime = this.startsFromTime.toUtcISOString();
    }

    if (this.viewMode !== null) {
      params.view = this.viewMode.toString();
    }

    return params;
  }

  toScotchApiSearchQuery(): ScotchApiSearchQuery {
    const params: ScotchApiSearchQuery = {};

    if (this.coordinate !== null) {
      params.lat = this.coordinate.lat.toString();
      params.lng = this.coordinate.lng.toString();
    }

    if (this.searchArea !== null) {
      params.area = this.searchArea.polyline;
    } else {
      params.radius = DEFAULT_RADIUS.toString();
    }

    if (this.seats !== null) {
      params.seats = this.seats.toString();
    }

    if (this.startsFromTime !== null) {
      params.starts_from_time = this.startsFromTime.toUtcISOString();
      params.starts_to_time = this.startsFromTime
        .plus({ hours: 1 })
        .toUtcISOString();
    }

    return params;
  }
}
